<template>
    <!-- Quote Edit Form -->
    <div id="quote-edit">
      <customer-rmas-edit-header />
      <section class="quotes--quote-summary">
        <b-card>
            <b-row>
              <b-col cols="2">
                <div class="tools first-row">
                  <b-button v-if="checkClaim(CAN_EDIT_RMAS)" @click="openRmaPartsModal(true)" size="sm" variant="primary" class="mr-2">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    Add Item
                  </b-button>
                  <b-button v-if="checkClaim(CAN_RECIEVE_RMAS) && customerrma.rmaTermsId == 225" @click="onReceiveItem" size="sm" variant="primary"
                    :disabled="Object.keys(customerRMALine).length == 0 || !customerrma.isAuthorized">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    Receive Item
                  </b-button>
                  <b-button v-if="checkClaim(CAN_RECIEVE_RMAS) && canReorder" @click="onReorderingSOFromRmaLine" size="sm" variant="primary"
                    :disabled="Object.keys(customerRMALine).length == 0 || !customerrma.isAuthorized  || isReordering">
                    <i :class="isReordering ? 'fa fa-spinner fa-pulse fa-fw' : 'fa fa-plus'" aria-hidden="true"></i>
                    Reorder Item
                  </b-button>
                </div>
              </b-col>
              <b-col v-if="checkClaim(CAN_ADD_VENDOR_RETURNS)">
                <!-- If the terms is Return, then show Vendor RMA -->
                <b-button size="sm" variant="primary" v-b-modal.create-vrma-from-rma class="mr-2" v-if="customerrma.rmaTermsId == 225"
                  :disabled="Object.keys(customerRMALine).length == 0 || !customerrma.isAuthorized">
                  <i class="fa fa-plus" aria-hidden="true"></i>
                  Create V-RMA
                </b-button>
                <!-- If the terms is Return, then show RMA Inspection Report -->
                <b-button size="sm" variant="primary" class="mr-2" v-if="customerrma.rmaTermsId == 225"
                  :disabled="isSavingInspection || Object.keys(customerRMALine).length == 0 || !customerrma.isAuthorized" @click="onCreationRmaInspection">
                  <i v-show="isSavingInspection" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                  Create RMA Inspection
                </b-button>
                <b-button size="sm" variant="primary" class="mr-2"
                  :disabled="Object.keys(customerRMALine).length == 0 || !customerrma.isAuthorized"
                  @click="$refs['rma-ncm-modal'].show()">
                  Create NCM
                </b-button>
                <b-button size="sm" variant="primary" v-if="creditMemoByReference.length == 0" @click="onCreateCreditMemo(customerrma.rmaActionId == 479)" :disabled="!customerrma.isAuthorized">
                  Create Credit Memo
                </b-button>
                <b-modal
                  id="rma-inspection-modal"
                  ref="rma-inspection-modal"
                  size="xl"
                  hide-footer
                  header-close-label="Cancel"
                  :title="`Manage Report - RMA Inspection`"
                  scrollable
                >
                  <add-form-wizard :reportName="'RmaInspection'"
                    :inventoryDetails="{...customerRMALine, quantitySold: customerRMALine.qtyReturning}"
                    :inspectionDetails="inspectionDetails"
                    @getReports="$refs['inspection-report-lower-tab'].refreshData()"
                    :onRmaInspection="true" />
                </b-modal>
                <ncm-report-component :modalId="'rma-ncm-modal'" ref="rma-ncm-modal" :rmaLineProp="customerRMALine" @savedNcm="$refs['ncm-report-lower-tab'].getData()" />
                <add-credit-memo componentBtn ref="rma-creditmemo-modal" :rmaId="customerRMAId" :isPending="customerrma.rmaTermsId == 225 && !IsRmaReceived" :isRefund="creditMemoObj.isRefund"
                  :propCompanyId="creditMemoObj.companyId" :propCompanyName="creditMemoObj.companyName" :propAmount="creditMemoObj.amount" @created="createdCreditMemo" />
              </b-col>
              <b-col>
              </b-col>
            </b-row>
          <b-row class="mt-2">
            <customer-rma-lines
              :key="componentKey"
              :customerRMAId="customerRMAId"
              :showAllGridRows="showAllGridRows"
              :gridId="gridId"
              @showEdit="showEdit"
              @showDelete="showDelete"
              @selectedCustomerRMALine="setCustomerRMALine"
            />
          </b-row>
        </b-card>
      </section>
      <b-tabs>
        <b-tab title="Summary">
          <b-row class="justify-content-between mt-2">
            <b-col cols="2">
              <div class="buttom-container">
                <div class="d-flex justify-content-between">
                  <a class="input-header-txt">Print Comments</a>
                </div>
                <lookup-dropdown
                  :options="printComments"
                  moduleName="printComments"
                  propKey="name"
                  resource="PrintComments"
                  lookupId="19"
                  class="mb-2"
                  @change="onPrintCommentChange"
                />
                <b-textarea rows="5" v-model.trim="customerrma.comments" />
              </div>
              <div class="buttom-container mt-2">
                <b-form-group label="Internal Comments">
                  <b-textarea rows="5" v-model="customerrma.internalComments" />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="3">
            </b-col>
            <b-col cols="5">
              <b-tabs>
                <b-tab title="Summary" active>
                  <quote-summary v-bind:quote="customerrma" />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    Charges &nbsp;<b-badge variant="primary">{{ customerRmaCharges.length }}</b-badge>
                  </template>
                  <charges-list :customerRmaId="customerRMAId" />
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_ALL_SALES_ORDERS)" >
          <template v-slot:title>
            Sales Order &nbsp;<b-badge variant="primary">{{ salesOrdersCustom.length }}</b-badge>
          </template>
          <sales-orders :dataBy="'salesOrder'" :salesOrderLineId="customerRMALine.soLineId" :gridId="soLineGridId" />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_ALL_POS)" >
          <template v-slot:title>
            Purchase Order &nbsp;<b-badge variant="primary">{{ purchaseOrderLines.length }}</b-badge>
          </template>
          <purchase-order-line :purchaseOrderLineId="customerRMALine.poLineId" />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_CREDIT_MEMO)" >
          <template v-slot:title>
            Invoice &nbsp;<b-badge variant="primary">{{ invoicesFiltered.length }}</b-badge>
          </template>
          <invoice-line :invoiceLineId="customerRMALine.invoiceLineId" :gridId="invoiceLineGridId" isInvoiceTab />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_CREDIT_MEMO)" >
          <template v-slot:title>
            Credit Memos &nbsp;<b-badge variant="primary">{{ creditMemoByReference.length }}</b-badge>
          </template>
          <credit-memos ref="cmemo" :rmaId="customerRMALine.rmaId" :contactEmail="customerrma.contactEmail" />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_ALL_VENDOR_RETURNS)">
          <template v-slot:title>
            Vendor RMA &nbsp;<b-badge variant="primary">{{ vrmasListByRmaLine.length }}</b-badge>
          </template>
          <vendor-rma :rmaLineId="customerRMALine.id" />
        </b-tab>
        <b-tab>
          <template v-slot:title>
            NCM Report &nbsp;<b-badge variant="primary">{{ ncmReportsByParam.length }}</b-badge>
          </template>
          <ncm-report ref="ncm-report-lower-tab" :rmaLineId="customerRMALine.id" />
        </b-tab>
        <b-tab>
          <template v-slot:title>
            Inspection Report &nbsp;<b-badge variant="primary">{{ rmaInspectionReportsList.length }}</b-badge>
          </template>
          <inspection-report ref="inspection-report-lower-tab" :rmaLineId="customerRMALine.id" :rmaLinePartId="customerRMALine.partId" />
        </b-tab>
        <b-tab>
          <template v-slot:title>
            CAR/SCAR &nbsp;<b-badge variant="primary">{{ correctiveActionReportsList.length }}</b-badge>
          </template>
          <CarScarReports :purchaseOrderLineId="customerRMALine.poLineId" :otherData="{invoiceId: customerrma.invoiceId, companyId:customerrma.companyId,companyName:customerrma.companyName,}" />
        </b-tab>
        <b-tab title="Documents and Images">
          <documents-and-images :reference="'customerRMALineId'" :refId="customerRMALine.id" :partId="customerRMALine.partId" />
        </b-tab>
      </b-tabs>
      <div class="d-flex justify-content-between mt-2">
        <div></div>
        <div class="mr-3">
          <b-button
            type="button"
            variant="secondary"
            size="sm"
            @click="onCancel()"
            v-if="checkClaim(CAN_VIEW_ALL_RMAS)"
          >Exit</b-button>
          <b-button
            v-if="checkClaim(CAN_EDIT_RMAS)"
            variant="primary"
            type="submit"
            class="ml-2"
            size="sm"
            :disabled="isSaving"
            @click="onSaveRMA(false)"
          ><i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save and Continue</b-button>
          <b-button
            v-if="checkClaim(CAN_EDIT_RMAS) && checkClaim(CAN_VIEW_ALL_RMAS)"
            variant="primary"
            type="submit"
            class=" ml-2"
            size="sm"
            :disabled="isSaving"
            @click="onSaveRMA(true)"
          ><i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save and Exit</b-button>
          <b-button
            v-if="checkClaim(CAN_AUTHORIZE_RMAS)"
            :variant="customerrma.isAuthorized ? 'success' : 'danger'"
            size="sm"
            class=" ml-2"
            :disabled="isSaving"
            @click="onSaveRMA(false, !customerrma.isAuthorized)"
          >
            <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>{{ customerrma.isAuthorized ? 'Unauthorize' : 'Authorize' }}
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            @click="onEmailRMA"
            class="ml-2"
            :disabled="!customerrma.isAuthorized"
          >
            <i v-show="isEmailLoading" class="fa fa-spinner fa-pulse fa-fw"></i> Send Email
          </b-button>
          <send-emails :sendEmailData="sendEmailData"></send-emails>
          <!-- <b-button
            variant="primary"
            size="sm"
            @click="$bvModal.show('view-fast-report')"
            class="ml-2"
            :disabled="!customerrma.isAuthorized"
          >
            <i v-show="isPrintLoading" class="fa fa-spinner fa-pulse fa-fw"></i> Print
          </b-button> -->
        </div>
    </div>

    <rma-part-view :isAddPart="rmaAddPartAction" :rmaPart="onEditRMAPart" :rmaId="customerrma.id" @onRefresh="onSaveRMA(false)"></rma-part-view>
    <pending-vrma-view :vendorId="customerRMALine.vendorId" :rmaLine="customerRMALine"  />

    <b-modal size="xl" id="receive-rma-modal" ref="receive-rma-modal" hide-footer>
      <rma-receive ref="receiveRma" :rmaId="customerRMAId" :rmaLineObj="customerRMALine" :isCredit="customerrma.rmaTermsId == 479" @received="onSaveRMA(false, true)"
        @onRedirectToList="$bvModal.hide('receive-rma-modal')" @onCredit="onCreateCreditMemo" />
    </b-modal>

    <!-- <fast-report-viewer :parameter="customerRMAId" :moduleName="'RMAs'" /> -->
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
//import debounce from 'lodash/debounce';
import { GRID_ID, REPORTS_CONSTANTS } from '@/shared/constants';
//import { FIELDS as SALES_ORDER_FIELDS } from '@/pages/SalesOrders/components/SalesOrderLines/constants'

 import RequirementDetails from '@/shared/components/RequirementDetails/index';

import CustomerRmaLines from '@/pages/Customerrmas/components/CustomerrmasLines';
//import QuoteHeader from '@/pages/Quotes/components/QuoteHeader';
import CustomerRmasEditHeader from './components/header/index';
import QuoteSummary from '@/pages/Quotes/components/EditQuote/components/QuoteSummary';
import Charges from '@/pages/Quotes/components/EditQuote/components/Charges';
import PartForm from '@/shared/components/Parts';
import QuoteLineEdit from '@/shared/components/QuoteLine';
//import Sources from '@/shared/components/Sources';
//import Offers from '@/shared/components/Offers';
import Requirements from '@/shared/components/Requirements';
import SalesOrders from '@/shared/components/SalesOrders';
import SendEmails from '@/shared/components/SendEmails/index';
import ItemRequirements from '@/shared/components/ItemRequirements/index';
import ChargesList from '@/shared/components/ChargesList/index';
import NcmReport from '@/shared/components/NcmReport';
import CarScarReports from '@/shared/components/CarScarReports';
import Calculator from '@/shared/components/Calculator';
import RmaPartView from '@/pages/Customerrmas/components/RmaParts';
import PendingVrmaView from '@/pages/Vendorrmas/components/add/RmaModal';
import CreditMemos from '@/shared/components/CreditMemos';
import VendorRma from '@/shared/components/VRMA';
import DocumentsAndImages from '@/shared/components/DocumentsAndImages';
import RmaReceive from '@/pages/Shipping/components/ReceiveRMADetails';
import FastReportViewer from '@/shared/components/FastReportViewer';
import PurchaseOrderLine from '@/shared/components/PurchaseOrderLine';
import InvoiceLine from '@/shared/components/InvoiceLines';
import AddFormWizard from '@/shared/components/InspectionReport/components/Form/AddFormWizard';
import InspectionReport from '@/shared/components/InspectionReport';
import NcmReportComponent from '@/pages/NonconformanceReport/components/Form'
import AddCreditMemo from '@/pages/CreditMemos/components/edit';
//import reportApi from '@/resources/reportApi';

export default {
  data() {
    return {
      mergedObj: {},
      gridId: GRID_ID.SALES_ORDER_LINES,
      customerRMALine: {},
      customerRMALinePartForm: {},
      shippingObj: {
        sold: 0,
        shipped: 0,
      },
      shippingFormObjArr: [],
      showAllGridRows: false,
      rmaAddPartAction: true,
      addPartDetails: {},
      purchaseOrdrLine: {},
      onEditRMAPart: {},
      invoiceLinesSelected: {},
      modalId: 'rma-part-modal',
      requiredPostFields: [
        'quantityReturning', 'rmaReasonId'
      ],
      requiredPutFields: [
        'qtyReturning', 'rmaReasonId'
      ],
      isEmailLoading: false,
      isPrintLoading: false,
      checkedQuoteReports: [],
      selectedPendingVrmaId: 0,
      sendEmailData:{},
      isSaving: false,
      soLineGridId: GRID_ID.SALES_ORDER_LINES_TAB_GRID,
      poLineGridId: GRID_ID.PURCHASE_ORDER_LINES_TAB_GRID,
      invoiceLineGridId: GRID_ID.INVOICE_LINES_TAB_GRID,
      isSavingInspection: false,
      isReordering: false,
      inspectionDetails: {},
      creditMemoObj: {},
      componentKey: 0,
    };
  },
  metaInfo() {
    return {
      title: `Customer RMA: ${this.customerRMAId} - ${this.customerrma.companyName}`,
    }
  },
  components: {
    RequirementDetails,
    CustomerRmaLines,
    CustomerRmasEditHeader,
    QuoteSummary,
    Charges,
    ChargesList,
    Requirements,
    ItemRequirements,
    PartForm,
    QuoteLineEdit,
    Calculator,
    RmaPartView,
    PendingVrmaView,
    CreditMemos,
    VendorRma,
    SendEmails,
    DocumentsAndImages,
    RmaReceive,
    NcmReport,
    CarScarReports,
    FastReportViewer,
    SalesOrders,
    PurchaseOrderLine,
    InvoiceLine,
    AddFormWizard,
    InspectionReport,
    NcmReportComponent,
    AddCreditMemo
  },
  computed: {
    // ...mapGetters('quoteDetails', ['quoteById']),
    ...mapGetters('quotes', ['quote']),
    ...mapGetters('lookup', ['rmaReasons','printComments']),
    ...mapGetters('customerrmas', ['customerrma']),
    ...mapState('invoiceLines', ['invoiceLines']),
    ...mapGetters('vendorrmas',  ['vrmasListByRmaLine']),
    ...mapGetters('ncmReports', ['ncmReportsByParam']),
    ...mapGetters('carScarReports', { correctiveActionReportsList: 'gridList'}),
    //...mapGetters('companies', ['company']),
    ...mapState('customerrmas', { customerRmaCharges: 'charges' }),
    ...mapState('customerRmasLines', ['customerRMALines']),
    ...mapGetters('salesOrders', ['salesOrdersCustom']),
    ...mapGetters('purchaseorders', [ 'purchaseOrderLines' ]),
    ...mapGetters('invoices', [ 'invoicesFiltered' ]),
    ...mapGetters('account', ['userId']),
    ...mapGetters('inspectionReports', ['rmaInspectionReportsList']),
    ...mapGetters('creditMemos', ['creditMemoByReference']),

    customerRMAId() {
      return this.$route.params.id;
    },
    companyId() {
      return this.$route.params.companyId;
    },
    isSaveEnable() {
      return this.validateRequiredFields();
    },
    reportOption() {
      return REPORTS_CONSTANTS.filter(x => x.module == 'RMAs');
    },
    canReorder() {
      // If terms is equal to dispose and action is replaced, then we can reorder
      return this.customerrma.rmaTermsId == 224 && this.customerrma.rmaActionId == 478;
    },
    receivedSum() {

    },
    IsRmaReceived() {
      let allQtyReturning = this.customerRMALines.reduce((acc, item) => acc + item.qtyReturning, 0);
      let allQtyReceived = this.customerRMALines.reduce((acc, item) => acc + item.qtyReceived, 0);

      return allQtyReturning <= allQtyReceived;
    }
  },
  methods: {
    ...mapActions('customerrmas', [
      'getById',
      'onAddRMALine',
      'onUpdateRMALine',
      'onDeleteRMALine',
      'manage',
      'authorizeRMA',
      'emailRMA',
      'updateRmaTotals',
    ]),
    ...mapActions('invoiceLines', [ 'getInvoiceLines' ]),
    ...mapActions('customerRmasLines', ['updateCustomerRMALine', 'getCustomerRMALines', 'createRmaInspection', 'reorderSOFromRmaLine']),
    ...mapActions('companies', { companyById: 'getById' }),
    ...mapActions('requirementAdd', ['getShipViaList']),
    ...mapActions('refundMemo', { manageRefund: 'manageRefundMemo' }),
    setCustomerRMALine(customerRMALine) {
      this.customerRMALine = customerRMALine;
    },
    async saveLineCalculator(customerRMALineObj) {
      await this.updateCustomerRMALine(customerRMALineObj);

       this.getById(this.customerRMAId);
    },
    openRmaPartsModal(isAddPart) {
      this.rmaAddPartAction = isAddPart;
      this.$bvModal.show(this.modalId);
    },
    onReceiveItem() {
      // this.$refs.receiveRma.handleClear();
      this.$bvModal.show('receive-rma-modal');
    },
    showEdit($e) {
      console.log($e, "E")
      this.onEditRMAPart = $e;
      this.openRmaPartsModal(false);
    },
    async showDelete(data) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete this RMA Line for Part ${data.partNumber}?`});
      if (deleteConfirmed) {
        const result = await this.onDeleteRMALine({
          rmaId: data.rmaId,
          rmaLineId: data.id
        });
        this.onClear();
        this.getCustomerRMALines(this.customerrma.id);
        this.$snotify.success('Deleted RMA Line', 'Customer RMA');
      }
    },
    onClear() {
      this.invoiceLinesSelected = {};
      this.addPartDetails = {};
      this.customerRMALine = {};
    },
    async onSaveRMA(exit, isAuthorize = false) {
      try {
        this.isSaving = true;
        await this.manage({ rmaDto: this.customerrma, isAuthorize });
        this.isSaving = false;
        this.componentKey += 1;
        if (exit) {
          this.$router.push({ name: 'customerrmas' });
        }
        this.$refs['cmemo'].getCreditMemos();
      } catch (e) {
        /*console.log(e.message);*/
        this.isSaving = false;
      }
    },
    onCancel() {
      this.$router.push({ name: 'customerrmas' });
    },
    validateRequiredFields() {
      let requiredFields = (this.rmaAddPartAction) ? this.requiredPostFields : this.requiredPutFields;
      let objFormProps = (this.rmaAddPartAction) ? this.addPartDetails : this.onEditRMAPart;

      if(this.rmaAddPartAction && !Object.keys(this.invoiceLinesSelected).length) {
        return false;
      }

      for (let i = 0; i < requiredFields.length; i++) {
        let field = requiredFields[i];
        if (objFormProps[field] == undefined || objFormProps[field] == null) {
          return false;
          break;
        }
      }

      return true;
    },
    async onAuthorizingRMA() {
        try {
          await this.onSaveRMA(false);
          this.isSaving = true;
          await this.authorizeRMA({
            rmaId: this.customerrma.id,
            authorize: !this.customerrma.isAuthorized
          });
          this.isSaving = false;
        } catch (e) {
          this.isSaving = false;
          /*console.log(e.message);*/
        }
      },
      async onEmailRMA() {
        this.sendEmailData = {template: 'RMA', source:'RMA',to:this.customerrma.contactEmail,ReferenceId:this.customerRMAId, reportSelectionOptions: this.reportOption}
        this.$root.$emit('bv::show::modal', 'send-email-modal');
      },
      onPrintRMA() {
        // this.$refs['reportSelectionModal'].show();
      },
    onPrintCommentChange({ text, name }) {
      this.customerrma.comments = (this.customerrma.comments) ? this.customerrma.comments + '\n' + (text || name) : (text || name);
    },
    async onCreationRmaInspection() {
      try {
        this.isSavingInspection=true;
        let resData = await this.createRmaInspection({line: this.customerRMALine, userId: this.userId});
        this.isSavingInspection = false;
        if(resData.id) {
          this.inspectionDetails = resData;
          this.$refs['inspection-report-lower-tab'].refreshData();
          this.$bvModal.show('rma-inspection-modal');
        }
      } catch {
        this.isSavingInspection= false;
      }
    },
    async onReorderingSOFromRmaLine() {
      this.isReordering = true;
      const result = await this.reorderSOFromRmaLine(this.customerRMALine.id).catch(() => this.isReordering = false);

      if (result.status == 200)
      {
        this.isReordering = false;
        this.onSaveRMA(false, true);
        console.log(this.customerRMALine)
        if (this.customerRMALine.salesOrderId > 0)
        {
          this.$router.push({
            name: 'salesorders.edit',
            params: { id: this.customerRMALine.salesOrderId },
          });
        }
      }
    },
    async onCreateCreditMemo(isCreditMemo) {
      var toCredit = (this.customerrma.totalConverted > this.customerrma.invoiceAmountPaid)
        ? this.customerrma.totalConverted - this.customerrma.invoiceAmountPaid : this.customerrma.totalConverted;

      const confirmation = await this.openConfirmBox({
          message: `Customer paid the invoice for amount $${this.customerrma.invoiceAmountPaid}. Would you like to issue a credit memo for $${toCredit}?`,
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
        });

        if (confirmation) {
          this.creditMemoObj = {
            companyId: this.customerrma.companyId,
            companyName: this.customerrma.companyName,
            contactId: this.customerrma.contactId,
            // amount: toCredit,
            amount: this.customerrma.totalConverted,
            isRefund: !isCreditMemo
          };

          this.$refs['rma-creditmemo-modal'].openModal()
        }
    },
    createdCreditMemo() {
      this.onSaveRMA(false, true);
      this.$refs['cmemo'].getCreditMemos();
    },
    async onCreateRefundMemo() {
      var remainingRMA = 0;
      var canBeCreatedRefund = null;

      // If invoice has already been paid...
      if (this.customerrma.invoiceAmountPaid > 0) {
        const isPartialPaid = false;

        // If it still has a balance...
        if (this.customerrma.totalConverted > this.customerrma.invoiceAmountPaid) {
          remainingRMA = this.customerrma.totalConverted - this.customerrma.invoiceAmountPaid;
          isPartialPaid = true;
        }

        const memo = {
          companyId: this.customerrma.companyId,
          companyName: this.customerrma.companyName,
          contactId: this.customerrma.contactId,
          amount: (isPartialPaid) ? this.customerrma.invoiceAmountPaid : this.customerrma.totalConverted,
        };

        await this.manageRefund(memo);
      } else {
        remainingRMA = this.customerrma.totalConverted;
        canBeCreatedRefund = 'Refund Memo cannot be created. '
      }

      if (remainingRMA > 0) {
        const confirmation = await this.openConfirmBox({
          message: `${canBeCreatedRefund}Customer paid the invoice for amount $${this.customerrma.invoiceAmountPaid}. Would you like to issue a credit memo for $${remainingRMA}?`,
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
        });

        if (confirmation) {
          this.creditMemoObj = {
            companyId: this.customerrma.companyId,
            companyName: this.customerrma.companyName,
            contactId: this.customerrma.contactId,
            amount: remainingRMA,
          };

          this.$refs['rma-creditmemo-modal'].openModal()
        }
      }
    }
  },
  mounted() {
    this.setContainerLoader(true);
    this.getById(this.customerRMAId).then(async (res) => {
      this.setContainerLoader(false);
    }).catch(() => {
      this.setContainerLoader(false);
      //return back to listing page because error in fetch record
      this.$router.push({name: 'customerrmas'});
    });
  },
};
</script>
